import { useSelector, useDispatch } from "react-redux";
import { toggle } from "../../app-store/showSideBarSlice";

function MobileNav({ firstCrumb = "Dashboard" }) {
  const showSideBar = useSelector((state) => state.showSideBar.value);
  const dispatch = useDispatch();
  const pathName = window.location.pathname;
  const crumb = pathName.split("/")[2];
  return (
    <nav className="d-lg-none bg-primary">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <span className="text-white">{firstCrumb}</span>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                <span className="text-white">
                  {crumb ? crumb.charAt(0).toUpperCase() + crumb.slice(1) : ""}
                </span>
              </li>
            </ol>
          </div>
          <div className="col-auto">
            <div className="navbar-dark">
              <button
                className={`navbar-toggler ${showSideBar ? "" : "collapsed"}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#sidenavCollapse"
                aria-controls="sidenavCollapse"
                aria-expanded={showSideBar}
                aria-label="Toggle navigation"
                onClick={() => dispatch(toggle())}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default MobileNav;
